<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-form @submit.prevent="saveEmail" lazy-validation ref="form">
        <v-card>
          <v-card-text>
            <v-container>
              <v-col cols="12">
                <v-text-field
                  type="email"
                  :rules="emailRules"
                  v-model="email"
                  label="Email*"
                  required
                ></v-text-field>
              </v-col>
            </v-container>
            <normal
              ><b>{{
                $t("modal.theEmailIsNecessaryToSendYouTheTicketOrInvoices")
              }}</b></normal
            >
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" type="submit" text>{{
              $t("common.keep")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
// eslint-disable-next-line no-control-regex
let emailRegEx = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

export default {
  name: "EmailModal",
  data() {
    return {
      dialog: false,
      email: "",
      emailRules: [
        v => !!v || this.$t("common.emailIsRequired"),
        v => emailRegEx.test(v) || this.$t("common.theEmailMustBeValid")
      ]
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    saveEmail() {
      if (this.$refs.form.validate()) {
        this.$store.commit("setCustomerEmail", this.email);
        this.dialog = false;
      }
    }
  }
};
</script>

<style></style>
